import TableWidgetCell from './TableWidgetCell'

export default class TableWidgetRow {
    constructor(cells_count = 3) {
        this.cells = []
        for (let i = 0; i < cells_count; i++) {
            this.cells.push(new TableWidgetCell())
        }
    }
}
